export const GET_PROJECTS = 'GET_PROJECTS';
export const SUBMIT_FORM = 'SUBMIT_FORM';
export const LOADING = 'LOADING';
export const ERROR = 'ERROR';
export const CLEAR_ERRORS = 'CLEAR_ERRORS'